/**
 * Legacy cart-page DOM rewrites keyed by `<cpc …>` elements — verbatim from
 * v1 process_cart_page.js CARTPAGE_adjustLineItems' non-faster-checkout
 * branch (research/05 §5.2.8; REQ-CART-3). Preserved quirks: dollar-`amount`
 * vs cent-total mixing (§8.14 — zero-priced lines add
 * `variantAmount * qty * 100` to the cent total, then totals divide by 100),
 * the Nova `cartData.currency` mutation INSIDE the loop, the
 * duplicate-variant last-quantity quirk (cpc_quantity keeps the LAST match),
 * and totals rewritten only when `cpc_variantData` is non-empty. All DOM
 * writes go through the BUNDLED jQuery (DIV-004; v1 used the theme's).
 */
import { GetTargetCurrency, GetAmountAfterConversion } from "../currency";
import { updatePrice } from "./totals";
import $ from "jquery";

export function LegacyCartRewrites(
  cartData: any,
  allVariantsFromCart: any[],
  cpc_variantData: any,
  cart_total_price: any,
  isNovaCurrencyCompatible: boolean,
): void {
  if (!!cpc_variantData && cpc_variantData.length > 0) {
    for (let i = 0; i < cpc_variantData.length; i++) {
      let currentVariant = cpc_variantData[i];
      let cpc_quantity = 0;
      $.each(allVariantsFromCart, function (i: any, cartVariant: any) {
        if (cartVariant.item.variant_id == currentVariant.shopifyVariantId) {
          let variantAmount = currentVariant.amount;
          //This variant price info is missing from cart
          cpc_quantity = cartVariant.item.quantity;
          if (cartVariant.item.price === 0) {
            if (isNovaCurrencyCompatible) {
              let user_curr = cartData.currency;
              const result = GetAmountAfterConversion(parseFloat(variantAmount), user_curr, null);
              variantAmount = result;
            }
            cart_total_price += variantAmount * cpc_quantity * 100;
          }
        }
      });
      if (isNovaCurrencyCompatible) {
        let user_curr = cartData.currency;
        cartData.currency = GetTargetCurrency(null);
        const result = GetAmountAfterConversion(parseFloat(currentVariant.amount), user_curr, cartData.currency);
        currentVariant.amount = result;
      }

      $(
        "cpc.product_title[data-id='" +
        currentVariant.shopifyVariantId +
        "']",
      ).html(currentVariant.shopifyProductTitle);

      updatePrice(
        "cpc.original_price[data-id='" +
        currentVariant.shopifyVariantId +
        "']",
        cartData.currency,
        currentVariant.amount,
        false,
        isNovaCurrencyCompatible,
      );
      updatePrice(
        "cpc.price[data-id='" + currentVariant.shopifyVariantId + "']",
        cartData.currency,
        currentVariant.amount,
        false,
        isNovaCurrencyCompatible,
      );
      updatePrice(
        "cpc.discounted_price[data-id='" +
        currentVariant.shopifyVariantId +
        "']",
        cartData.currency,
        currentVariant.amount,
        false,
        isNovaCurrencyCompatible,
      );
      updatePrice(
        "cpc.final_line_price[data-id='" +
        currentVariant.shopifyVariantId +
        "']",
        cartData.currency,
        currentVariant.amount * cpc_quantity,
        false,
        isNovaCurrencyCompatible,
      );
      updatePrice(
        "cpc.line_price[data-id='" + currentVariant.shopifyVariantId + "']",
        cartData.currency,
        currentVariant.amount * cpc_quantity,
        false,
        isNovaCurrencyCompatible,
      );
      updatePrice(
        "cpc.original_line_price[data-id='" +
        currentVariant.shopifyVariantId +
        "']",
        cartData.currency,
        currentVariant.amount * cpc_quantity,
        false,
        isNovaCurrencyCompatible,
      );

      var itemImage = $(
        "img[data-cpcimageid='" + currentVariant.shopifyVariantId + "']",
      );
      if (
        itemImage !== undefined &&
        currentVariant.productImageUrl !== null &&
        itemImage.length > 0
      ) {
          for (let i = 0; i < itemImage.length; i++) {
            itemImage[i].setAttribute("src", currentVariant.productImageUrl);
            itemImage[i].setAttribute("data-src", currentVariant.productImageUrl);
          }
      }

      var productUrl = $(
        "a[data-cpcproducturl='" + currentVariant.shopifyVariantId + "']",
      );
      if (
        productUrl !== undefined &&
        currentVariant.productUrl !== null &&
        productUrl.length > 0
      ) {
        for (let i = 0; i < productUrl.length; i++) {
          productUrl[i].setAttribute("href", currentVariant.productUrl);
        }
      }
    }

    updatePrice(
     "cpc.final_price",
      cartData.currency,
      cart_total_price / 100,
      true,
      isNovaCurrencyCompatible,
    );
    updatePrice(
      "cpc.cart_total_price",
       cartData.currency,
       cart_total_price / 100,
       true,
       isNovaCurrencyCompatible,
     );
  }
}
